import { CommonModule }        from '@angular/common';
import { NgModule }            from '@angular/core';
import { StatusTextComponent } from '@shared/components/status-text/status-text.component';

@NgModule( {
	declarations: [
		StatusTextComponent
	],
	exports: [
		StatusTextComponent
	],
	imports: [
		// Angular
		CommonModule
	],
	providers: []
} )
export class StatusTextModule {}
